export const classes = {
  tableHead: 'bg-white whitespace-pre',
};

export const styles = {
  // TODO
  // cell: (minWidth?: number) => ({ minWidth }),
  cell: (minWidth?: number) => ({}),
};
